export const FETCH_LISTS = 'FETCH_LISTS';
export const FETCH_LIST = 'FETCH_LIST';
export const FETCH_LIST_LOGS = 'FETCH_LIST_LOGS';
export const UPDATE_LIST = 'UPDATE_LIST';
